export type TimelineKind = 'work' | 'inner';

export type TimelineEvent = {
  kind: TimelineKind;
  year: string;
  title: { ru: string; en: string };
  desc: { ru: string; en: string };
};

export const TIMELINE: TimelineEvent[] = [
  {
    kind: 'work',
    year: '2010s',
    title: {
      ru: 'IT / продукт / дизайн',
      en: 'IT / product / design',
    },
    desc: {
      ru: '15 лет в IT: системы, дизайн, продукты (Россия → Европа → США).',
      en: '15 years in IT: systems, design, product (RU → EU → US).',
    },
  },
  {
    kind: 'inner',
    year: '~2018',
    title: {
      ru: 'поворот в работу с людьми',
      en: 'shift to working with people',
    },
    desc: {
      ru: 'коучинг, фасилитация, групповые процессы — мост между системами и психикой.',
      en: 'coaching, facilitation, group work — a bridge between systems and the psyche.',
    },
  },
  {
    kind: 'work',
    year: '2018–2025',
    title: {
      ru: '@ponchiknews',
      en: '@ponchiknews',
    },
    desc: {
      ru: '7 лет: публичный голос, практические инсайты, системное мышление.',
      en: '7 years: public voice, practical insights, systems thinking.',
    },
  },
  {
    kind: 'inner',
    year: '2023–2025',
    title: {
      ru: 'Authentic Leadership',
      en: 'Authentic Leadership',
    },
    desc: {
      ru: 'программы про Self-leadership и внутреннюю устойчивость лидера.',
      en: 'programs on self-leadership and inner resilience for leaders.',
    },
  },
  {
    kind: 'work',
    year: '2025',
    title: {
      ru: 'Level 3: IFS + AI',
      en: 'Level 3: IFS + AI',
    },
    desc: {
      ru: 'интенсив по интеграции IFS (parts work) с LLM — без технического шума.',
      en: 'an intensive on integrating IFS (parts work) with LLMs — without technical noise.',
    },
  },
  {
    kind: 'work',
    year: '18 Dec',
    title: {
      ru: 'Founder OS #14',
      en: 'Founder OS #14',
    },
    desc: {
      ru: 'разговор: Be Your Own Guru — и как нейросеть помогает лучше понять себя.',
      en: 'conversation: Be Your Own Guru — and how an LLM helps you understand yourself.',
    },
  },
  {
    kind: 'inner',
    year: 'now',
    title: {
      ru: 'AI-экзоскелет практики',
      en: 'AI exoskeleton for practice',
    },
    desc: {
      ru: 'модульный стек и визуальные метафоры как интерфейс для внутренней работы.',
      en: 'a modular stack and visual metaphors as an interface for inner work.',
    },
  },
];


